import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { TrialLicenseActionTypes, TrialLicenseActions } from '../actions/trial-license.actions';
import {LicenseMgtService} from '../../../services/license-mgt.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {updateInfoType} from '../../../shareModel';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';


@Injectable()
export class TrialLicenseEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private licenseMgtService = inject(LicenseMgtService);

  constructor() {}

  GetTrialLicenses$ = createEffect(() => this.actions$.pipe(
    ofType(TrialLicenseActionTypes.GetTrialLicenses),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = {
        otp: user.otp
      }
      return this.licenseMgtService.ReadLicenseTrialMgt(params).pipe(
        map((res) => {
          if (res.result && Array.isArray(res.msg.body)) {
            return new featureActions.LoadTrialLicenses(res.msg.body);
          } else {
            return new featureActions.LoadTrialLicenses([]);
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.GetTrialLicensesFail());
        })
      );
    })
  ));
  AddTrialLicense$ = createEffect(() => this.actions$.pipe(
    ofType(TrialLicenseActionTypes.AddTrialLicenses),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.licenseMgtService.AddLicenseTrialMgt(params).pipe(
        switchMap((res) => {
          if (res.result) {
            const result = { ...res, type: updateInfoType.AddTrialLicense };
            return [new featureActions.GetTrialLicenses(), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction()]; // errmsg 0 means already has the same rule.
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddTrialLicense
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
  UpdateTrialLicense$ = createEffect(() => this.actions$.pipe(
    ofType(TrialLicenseActionTypes.UpdateTrialLicenses),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.licenseMgtService.UpdateLicenseTrialMgt(params).pipe(
        switchMap((res) => {
          if (res.result) {
            const result = { ...res, type: updateInfoType.UpdateTrialLicense };
            return [new featureActions.GetTrialLicenses(), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(res)]; // errmsg 0 means already has the same rule.
          }
        }),
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: error,
            type: updateInfoType.UpdateTrialLicense
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));
  DeleteTrialLicense$ = createEffect(() => this.actions$.pipe(
    ofType(TrialLicenseActionTypes.DeleteTrialLicenses),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        id: action.payload,
        otp: user.otp
      };
      return this.licenseMgtService.DeleteLicenseTrialMgt(params).pipe(
        switchMap((res) => {
          const result = { ...res, type: updateInfoType.DeleteTrialLicense };
          if (result.result) {
            return [new featureActions.GetTrialLicenses(), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: error,
            type: updateInfoType.DeleteTrialLicense
          };
          return of(new featureActions.UpdateInfoFailAction(res));
        })
      );
    })
  ));



}
